export default __webpack_public_path__ + "static/category-brochure-mobile-e55070743065c9f83d672144c2b7b701.png";